


























































import { Component, Vue, Provide } from "vue-property-decorator";
import DropdownList from "@/components/DropdownList.vue";
import BorderedButton from "@/components/BorderedButton.vue";
import AutoCompleteSearchInput from "@/components/AutoCompleteSearchInput.vue";
import CategoriesDataService, {
  CategorySelectorRow,
  CategoryViewDataRow,
  KeywordSearchResult
} from "@/services/CategoriesDataService";
import KeywordsDataService from "@/services/KeywordsDataService";

@Component({
  components: {
    AutoCompleteSearchInput,
    DropdownList,
    BorderedButton
  }
})
export default class KeywordSelector extends Vue {
  @Provide() private availableKeywords: {
    [searchKey: string]: KeywordSearchResult[] | null;
  } = {};
  @Provide() private categories: CategorySelectorRow[] = [];
  @Provide() private selectedCategory: CategorySelectorRow | null = null;
  @Provide() private subcategories: CategoryViewDataRow[] = [];
  @Provide() private selectedSubcategory: CategoryViewDataRow | null = null;

  mounted() {
    CategoriesDataService.getCategoriesExplorerList().then(response => {
      this.categories = response.data.sort((a, b) =>
        a.section_heading.localeCompare(b.section_heading)
      );
    });
  }

  handleRequestAutocompleteUpdate(searchKey: string) {
    this.availableKeywords[searchKey] = null;
    KeywordsDataService.getKeywordsMatchingSearch(searchKey).then(response => {
      this.availableKeywords = {
        ...this.availableKeywords,
        [searchKey]: response.data
      };
    });
  }

  handleSubmitSearch(search: string, match: KeywordSearchResult) {
    this.$emit("keyword-selected", search, match);
  }

  handleCategorySelected(category: CategorySelectorRow) {
    this.selectedCategory = category;
    this.subcategories = [];
    this.selectedSubcategory = null;
    CategoriesDataService.getSubcategories(category.section_letter).then(
      response => {
        this.subcategories = response.data.sort((a, b) =>
          a.field.localeCompare(b.field)
        );
      }
    );
  }

  handleSubcategorySelected(subcategory: CategoryViewDataRow) {
    this.selectedSubcategory = subcategory;
  }

  handleSearchButtonClicked() {
    if (!this.selectedCategory) {
      return;
    }
    this.$emit(
      "category-selected",
      this.selectedCategory,
      this.selectedSubcategory
    );
  }
}
